import React, { useEffect, useState } from "react";
import {
  Card,
  CardTitle,
  CardBody,
  Row,
  Col,
  Button,
  Input,
} from "reactstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { URL } from "../../api";
import axiosInstance from "../../Request";
const RuleEngineCard = () => {
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const cid = pathParts[2];
  const lid = pathParts[3];

  const [loading, setLoading] = useState(true);
  const [ruleData, setRuleData] = useState([]);
  const [reRunning, setReRunning] = useState(false);
  const [switchChecked, setSwitchChecked] = useState(false);
  const statusOptions = ["reject", "pass", "hold", "manual", "tbr","break"];
  const [productList, setProductList] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [checkAll, setCheckAll] = useState("");

  const fetchRuleData = async () => {
    try {
  setLoading(true); // Show loading spinner immediately when fetching

  const ts = Date.now(); // Cache buster
  const response = await axiosInstance.get(
    `${URL.RULE_ENGIEN}?customer_id=${cid}&lead_id=${lid}&_=${ts}`
  );

  const data = response.data;

  const normalizedData = data.map(rule => ({
    ...rule,
    actionStatus: rule.actionStatus || "",
  }));

  setRuleData(normalizedData);
} catch (error) {
  toast.error("Failed to fetch rule data.");
  console.error("Error fetching rule data", error);
} finally {
  setLoading(false);
}
  };

  useEffect(() => {
    fetchRuleData();
    fetchProductList();
  }, [cid, lid]);

  const fetchProductList = async () => {
    try {
      const res = await axiosInstance.get(URL.BRE_PRODUCT_LIST); // ✅ Replaced fetch with axiosInstance
      const data = res.data;

      if (res.status === 200) {
        const list = Array.isArray(data) ? data : [];
        setProductList(list);
      } else {
        toast.error(`Error fetching product list: ${data.message || "Unknown error"}`);
      }
    } catch (err) {
      console.error("Error:", err);
      toast.error("Error fetching product list. Please try again.");
    }
  };

  const handleStatusChange = async (index, newStatus) => {
    const updatedRules = [...ruleData];
    const rule = updatedRules[index];
    rule.actionStatus = newStatus;
    rule.updatedBy = localStorage.getItem("user_name");
    setRuleData(updatedRules);

try {
  const response = await axiosInstance.post(
    `${URL.RULE_UPDATE_STATUS}?customer_id=${cid}`,
    {
      id: rule.id,
      actionStatus: newStatus,
      user_id: localStorage.getItem("user_id"),
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  const result = response.data;

  toast.success(`Status updated for Rule ID ${rule.id}: ${newStatus}`);
} catch (error) {
  const message = error.response?.data?.message || "Failed to update status.";
  toast.error(message);
  console.error("Error updating status", error);
}
  };

  const handleSwitchToggle = () => {
    const newValue = !switchChecked;
    setSwitchChecked(newValue);
    setCheckAll(newValue ? "1" : "");
  };

  const handleProductSelect = (productCode) => {
    setSelectedProductId(productCode);
  };

  const handleReRun = async () => {
    setReRunning(true);
    setLoading(true); // show loading while re-running

try {
  const queryParams = new URLSearchParams({
    customer_id: cid,
    lead_id: lid,
    action: "f",
  });

  if (checkAll) queryParams.append("check_all", checkAll);
  if (selectedProductId) queryParams.append("product_code", selectedProductId);

  const response = await axiosInstance.get(
    `${URL.RERUN_RULE_ENGIEN}?${queryParams.toString()}`,
    {
      headers: {
        "Cache-Control": "no-cache",
      },
    }
  );

  const result = response.data;

  if (result.error) {
    toast.error(result.error || "Failed to re-run rules.");
    setLoading(false);
    setReRunning(false);
    return;
  }

  toast.success("Rules re-evaluated successfully.");

  // Normalize and set new rule data directly from re-run response
  const normalizedData = Array.isArray(result)
    ? result.map(rule => ({
        ...rule,
        actionStatus: rule.actionStatus || "",
      }))
    : [];

  setRuleData(normalizedData);
} catch (error) {
  toast.error("Error occurred during rule re-evaluation.");
  console.error("Re-run error:", error);
} finally {
  setLoading(false);
  setReRunning(false);
}
  };

  return (
    <Col xs="12">
      <Card className="card-stats mb-4">
        <CardBody>
          <Row>
            <Col>
              <CardTitle tag="h5" className="text-uppercase text-muted mb-3">
                <div className="justify-content-between align-items-center">
                  {/* Title */}
                  <span>Rule Engine</span>

                  {/* Right Side */}
                  <div className="d-flex align-items-center">
                    {/* Switch */}
                    <span className="mr-1">Run all Rules:</span>
                    <div className="custom-control custom-switch mr-2">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="customSwitch"
                        checked={switchChecked}
                        onChange={handleSwitchToggle}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="customSwitch"
                      ></label>
                    </div>

                    {/* Dropdown */}
                    <div className="mr-2">
                      <Input
                        type="select"
                        name="productSelect"
                        id="productSelect"
                        value={selectedProductId}
                        onChange={(e) => handleProductSelect(e.target.value)}
                      >
                        <option value="">Select Product</option>
                        {productList.map((product) => (
                          <option
                            key={product.ruleId}
                            value={product.productCode}
                          >
                            {product.productCode}
                          </option>
                        ))}
                      </Input>
                    </div>

                    {/* Re-run Button */}
                    <Button
                      color="primary"
                      onClick={handleReRun}
                      disabled={reRunning}
                    >
                      {reRunning ? "Re-running..." : "Re-run"}
                    </Button>
                  </div>
                </div>
              </CardTitle>

              {loading ? (
                <p className="text-success font-weight-bold">Loading...</p>
              ) : ruleData.length === 0 ? (
                <p>No rules found.</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead className="thead-light">
                      <tr>
                        <th>#</th>
                        <th>ID</th>
                        <th>Policy Name</th>
                        <th>Rule Name</th>
                        <th>Rule Code</th>
                        <th>Comment</th>
                        <th>Status</th>
                        <th>Updated By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ruleData.map((rule, index) => {
                        let bgColor = "#ffffff"; // default white
                            if (["reject", "break"].includes(rule.actionStatus)) {
                              bgColor = "#f8d7da"; // light red
                            } else if (rule.actionStatus === "hold") {
                              bgColor = "#fff3cd"; // light yellow
                            } else if (rule.actionStatus === "manual") {
                              bgColor = "#d4edda"; // light green
                            } else if (rule.actionStatus === "tbr") {
                              bgColor = "#ffe5b4"; // light orange
                            }

                        return (
                          <tr key={index} style={{ backgroundColor: bgColor }}>
                            <td>{index + 1}</td>
                            <td>{rule.id}</td>
                            <td>{rule.policyName}</td>
                            <td>{rule.ruleName}</td>
                            <td>{rule.ruleCode}</td>
                            <td>{rule.comment}</td>
                            <td style={{ verticalAlign: "middle", padding: "0.25rem" }}>
                              {["Approval", "Disbursal"].includes(rule.policyName) ? (
                                <div
                                  style={{
                                    fontSize: "12px",
                                    border: "none",
                                    padding: "2px 6px",
                                    backgroundColor: "transparent",
                                    width: "100%",
                                    minHeight: "24px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {rule.actionStatus || "-"}
                                </div>
                              ) : (
                                <select
                                  id={`select-${index}`}
                                  value={rule.actionStatus}
                                  onChange={(e) => handleStatusChange(index, e.target.value)}
                                  className="custom-select-small"
                                  style={{
                                    fontSize: "12px",
                                    border: "none",
                                    padding: "2px 6px",
                                    height: "24px",
                                    backgroundColor: "transparent",
                                    width: "100%",
                                  }}
                                >
                                  {statusOptions.map((status) => (
                                    <option key={status} value={status}>
                                      {status}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </td>
                            <td>{rule.updatedBy}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RuleEngineCard;
